
const getDefaultState = () => {
    return {
        adoptionData: {
            data: {
                misc: {},
            },
        },
        series: [],
        contacts: [],
        previousYears: [],
        seriesId: null,
    }
};

export default {
    state: getDefaultState(),
    getters: {
        adoptionCustomerId(state) {
            return (state.adoptionData || {}).customer_id;
        }
    },
    mutations: {
        resetAdoptions(state) {
            Object.assign(state, getDefaultState());
        },
        setAdoptionSeries(state, seriesId) {
            state.seriesId = seriesId;
            state.adoptionData = state.series.find(a => a.series_id == seriesId);
        },
        setOldAdoptions(state, data) {
            state.previousYears = data;
        },
        setAdoptions(state, data) {
            state.series = data;
        },
        setAdoptionData(state, data) {
            state.seriesId = data.series_id;
            state.adoptionData = data;
        },
        setAdoptionContacts(state, data) {
            state.contacts = data;
        }
    },
    actions: {
        getAdoptionData({context, state, commit}, customerId) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get(`/adoption/${customerId}`).then((response) => {
                    if (!response || !response.data || !response.data.adoption_data) {
                        reject(response);
                        return;
                    }
                    commit('setOldAdoptions', response.data.previous_adoptions)
                    commit('setAdoptions', response.data.adoption_data)
                    commit('setAdoptionData', response.data.adoption_data[0])
                    commit('setAdoptionSeries', response.data.adoption_data[0].series_id)
                    commit('setAdoptionContacts', response.data.contacts)
                    resolve(response.data);
                })
                .catch(reject);
            });
        },
    }
}
